// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-tool"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 14H10V21H3V14Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M14 14H21V21H14V14Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 3H10V10H3V3Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M3 14H10V21H3V14Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M14 14H21V21H14V14Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M3 3H10V10H3V3Z","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M18 3.75L18.7 5.29996L20.25 6L18.7 6.70004L18 8.25L17.3 6.70004L15.75 6L17.3 5.29996L18 3.75Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-tool')
export default class AiToolIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-tool',
    }
  }
}
